module.exports = __webpack_public_path__ + "img/A10.fbcebdde.svg";